// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminCvAnalysis {
  flex: 1 1;
  display: flex;
  overflow: auto;
  background: var(--Foreground);
  border-radius: 0.5rem;
}
.AdminCvAnalysis .DiscrepancySection {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
}
.AdminCvAnalysis .DiscrepancySection header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.AdminCvAnalysis .DiscrepancySection header h3 {
  font-size: 1rem;
  color: var(--TextColor);
  font-weight: 700;
  flex: 1 1;
}
.AdminCvAnalysis .DiscrepancySection header button {
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  color: var(--TextColor);
  font-size: 0.75rem;
  cursor: pointer;
}
.AdminCvAnalysis .DiscrepancySection header .ViewResume {
  color: var(--AccentColor);
  border-left: 0.0625rem solid var(--Stroke);
  gap: 0.375rem;
}
.AdminCvAnalysis .DiscrepancySection .EmptyDiscrepancyList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: calc(100% - 1rem);
  height: calc(100% - 1rem);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.AdminCvAnalysis .DiscrepancySection .EmptyDiscrepancyList h3 {
  font-size: 1rem;
  color: var(--TextColor);
  font-weight: 700;
}
.AdminCvAnalysis .DiscrepancySection .EmptyDiscrepancyList span {
  font-size: 0.75rem;
  color: #9B9B9B;
  text-align: center;
  text-wrap: balance;
}
.AdminCvAnalysis .DiscrepancySection .EmptyDiscrepancyList button {
  height: 1.5rem;
  width: 4rem;
  border: none;
  background: var(--AccentColor);
  border-radius: 0.25rem;
  font-size: 0.75rem;
  color: #ffffff;
  pointer-events: all;
  cursor: pointer;
}
.AdminCvAnalysis .HalfDiscrepancy {
  max-width: 16rem;
  min-width: 16rem;
}
.AdminCvAnalysis .ResumeSectionWrapper {
  display: grid;
  grid-template-columns: 0fr;
  height: 100%;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection {
  height: 100%;
  border-left: 0.125rem solid var(--Stroke);
  overflow: hidden;
  position: relative;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume {
  width: 20rem;
  height: calc(100% - 1rem);
  margin: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume header h3 {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--TextColor);
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume header button {
  background: none;
  border: none;
  color: var(--AccentColor);
  border-left: 0.0625rem solid var(--Stroke);
  font-size: 0.75rem;
  cursor: pointer;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume .Resume {
  flex: 1 1;
  height: 100%;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume .Resume iframe {
  width: 100%;
  height: 100%;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume .Resume .DOCpreview {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume .Resume .DOCpreview span {
  font-size: 0.75rem;
  color: var(--TextColor);
  text-align: center;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .HeaderResume .Resume .DOCpreview button {
  width: 8.5rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: #ffffff;
  background-color: var(--AccentColor);
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection .OverlayRes {
  display: none;
  width: 100%;
  min-width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.5019607843);
  color: #ffffff;
  font-size: 0.875rem;
  cursor: pointer;
}
.AdminCvAnalysis .ResumeSectionWrapper .ResumeSection:hover .OverlayRes {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
}
.AdminCvAnalysis .ChatSectionWrapper {
  flex: 1 1;
  border-left: 0.125rem solid var(--Stroke);
  display: none;
}
.AdminCvAnalysis .ShowResume {
  grid-template-columns: 1fr;
  transition: all 0.3s ease-in-out;
}
.AdminCvAnalysis .ShowChat {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/Components/AdminCvAnalysis/AdminCvAnalysis.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;EACA,qBAAA;AACF;AAAE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAGN;AAFM;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAIR;AAFM;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAIR;AAFM;EACE,yBAAA;EACA,0CAAA;EACA,aAAA;AAIR;AADI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAGN;AAFM;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;AAIR;AAFM;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAIR;AAFM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAIR;AAAE;EACE,gBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,aAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;AAEJ;AADI;EACE,YAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;AAGN;AAFM;EACE,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAIR;AAHQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAKV;AAJU;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAMZ;AAJU;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;AAMZ;AAHQ;EACE,SAAA;EACA,YAAA;AAKV;AAJU;EACE,WAAA;EACA,YAAA;AAMZ;AAJU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAMZ;AALY;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;AAOd;AALY;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,oCAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAOd;AAFM;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uCAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAIR;AADQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;AAGV;AAEE;EACE,SAAA;EACA,yCAAA;EACA,aAAA;AAAJ;AAEE;EACE,0BAAA;EACA,gCAAA;AAAJ;AAEE;EACE,aAAA;AAAJ","sourcesContent":[".AdminCvAnalysis{\n  flex: 1;\n  display: flex;\n  overflow: auto;\n  background: var(--Foreground);\n  border-radius: 0.5rem;\n  .DiscrepancySection{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 0.5rem;\n    header{\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      h3{\n        font-size: 1rem;\n        color: var(--TextColor);\n        font-weight: 700;\n        flex: 1;\n      }\n      button {\n        border: none;\n        background: none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.25rem;\n        color: var(--TextColor);\n        font-size: 0.75rem;\n        cursor: pointer;\n      }\n      .ViewResume {\n        color: var(--AccentColor);\n        border-left: 0.0625rem solid var(--Stroke);\n        gap: 0.375rem;\n      }\n    }\n    .EmptyDiscrepancyList{\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 0.5rem;\n      width: calc(100% - 1rem);\n      height: calc(100% - 1rem);\n      pointer-events: none;\n      user-select: none;\n      h3{\n        font-size: 1rem;\n        color: var(--TextColor);\n        font-weight: 700;\n      }\n      span{\n        font-size: 0.75rem;\n        color: #9B9B9B;\n        text-align: center;\n        text-wrap: balance;\n      }\n      button {\n        height: 1.5rem;\n        width: 4rem;\n        border: none;\n        background: var(--AccentColor);\n        border-radius: 0.25rem;\n        font-size: 0.75rem;\n        color: #ffffff;\n        pointer-events: all;\n        cursor: pointer;\n      }\n    }\n  }\n  .HalfDiscrepancy{\n    max-width: 16rem;\n    min-width: 16rem;\n  }\n  .ResumeSectionWrapper {\n    display: grid;\n    grid-template-columns: 0fr;\n    height: 100%;\n    overflow: hidden;\n    transition: all 0.3s ease-in-out;\n    .ResumeSection{\n      height: 100%;\n      border-left: 0.125rem solid var(--Stroke);\n      overflow: hidden;\n      position: relative;\n      .HeaderResume{\n        width: 20rem;\n        height: calc(100% - 1rem);\n        margin: 0.5rem;\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n        header{\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          gap: 0.5rem;\n          h3{\n            font-size: 0.875rem;\n            font-weight: 700;\n            color: var(--TextColor);\n          }\n          button {\n            background: none;\n            border: none;\n            color: var(--AccentColor);\n            border-left: 0.0625rem solid var(--Stroke);\n            font-size: 0.75rem;\n            cursor: pointer;\n          }\n        }\n        .Resume{\n          flex: 1;\n          height: 100%;\n          iframe{\n            width: 100%;\n            height: 100%;\n          }\n          .DOCpreview{\n            display: flex;\n            flex-direction: column;\n            gap: 1rem;\n            align-items: center;\n            justify-content: center;\n            width: 100%;\n            height: 100%;\n            span{\n              font-size: 0.75rem;\n              color: var(--TextColor);\n              text-align: center;\n            }\n            button{\n              width: 8.5rem;\n              height: 2rem;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              font-size: 0.75rem;\n              color: #ffffff;\n              background-color: var(--AccentColor);\n              border: none;\n              border-radius: 0.25rem;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n      .OverlayRes{\n        display: none;\n        width: 100%;\n        min-width: 100%;\n        height: 100%;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        background: #00000080;\n        color: #ffffff;\n        font-size: 0.875rem;\n        cursor: pointer;\n      }\n      &:hover{\n        .OverlayRes{\n          position: absolute;\n          top: 0;\n          left: 0;\n          display: flex;\n        }\n      }\n    }\n  }\n  .ChatSectionWrapper{\n    flex: 1;\n    border-left: 0.125rem solid var(--Stroke);\n    display: none;\n  }\n  .ShowResume {\n    grid-template-columns: 1fr;\n    transition: all 0.3s ease-in-out;\n  }\n  .ShowChat{\n    display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
